/**
 * `useSpotlight` — read + control the active spotlight. Spec §9.2.
 * Throws if used outside `<SpotlightProvider>` so misuse surfaces in dev.
 */
import { useContext } from 'react'

import { SpotlightContext } from './SpotlightProvider'
import type { SpotlightApi } from './types'

const ERR =
  'useSpotlight must be used inside <SpotlightProvider>. ' +
  'Add the provider near the top of the tree (see main.tsx).'

export function useSpotlight(): SpotlightApi {
  const ctx = useContext(SpotlightContext)
  if (!ctx) throw new Error(ERR)
  return { activate: ctx.activate, deactivate: ctx.deactivate, current: ctx.current }
}

/** Internal — exposes the registered configs as well as the API surface. */
export function useSpotlightInternal() {
  const ctx = useContext(SpotlightContext)
  if (!ctx) throw new Error(ERR)
  return ctx
}
